import { observer } from 'mobx-react-lite';
import React from 'react';
import { Checkbox } from '../Controls/Checkbox';
import {
  CheckboxContainer,
  GREEN,
  LIGHT_GRAY,
  MessageWrapper,
  RED,
  VerticalContainer,
} from '../Styles';

export const SettingCheckboxes = observer(
  ({ controls = [], direction, groupLabel, notImplemented}) => {
    
    const OuterContainer =
      direction === 'horizontal' ? MessageWrapper : VerticalContainer;
    const InnerContainer =
      direction === 'horizontal' ? CheckboxContainer : MessageWrapper;
    
    return (
      <OuterContainer>
        {groupLabel && <strong>{groupLabel}{notImplemented && ' - NOT IMPLEMENTED'}</strong>}
        {controls?.map(({ text, group, value, checkedValue, onClick }) => (
          <InnerContainer
            key={`settings_chk_parent_${group}_${text}_${value}`}
            highlight={checkedValue === value}
            highlightColor={checkedValue === 'off' ? RED : GREEN}
          >
            <Checkbox
              key={`settings_chk_${group}_${text}_${value}`}
              checkedValue={checkedValue}
              group={group}
              onClick={onClick}
              text={text}
              value={value}
              labelStyle={{
                color: LIGHT_GRAY,
                marginLeft: '10px',
              }}
            />
          </InnerContainer>
        ))}
      </OuterContainer>
    );
  },
);

export default SettingCheckboxes;


